import { render } from "./sortIcon.vue?vue&type=template&id=44545a9d&lang=pug"
import script from "./sortIcon.vue?vue&type=script&lang=js"
export * from "./sortIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/searchComp/sortIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44545a9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44545a9d', __exports__)) {
    api.reload('44545a9d', __exports__)
  }
  
  module.hot.accept("./sortIcon.vue?vue&type=template&id=44545a9d&lang=pug", () => {
    api.rerender('44545a9d', render)
  })

}


export default __exports__